'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VARIANT = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _ = _interopRequireWildcard(_lodash);

var _loader = require('./loader.cssm');

var _loader2 = _interopRequireDefault(_loader);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VARIANT = exports.VARIANT = {
  XSMALL_WHITE: 'xsmallWhite',
  XSMALL_BLUE: 'xsmallBlue',
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
};

var Loader = function (_Component) {
  _inherits(Loader, _Component);

  function Loader() {
    _classCallCheck(this, Loader);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(Loader).apply(this, arguments));
  }

  _createClass(Loader, [{
    key: 'render',
    value: function render() {
      var variant = this.props.variant;


      return _react2.default.createElement('div', { className: _loader2.default[variant] });
    }
  }]);

  return Loader;
}(_react.Component);

Loader.propTypes = {
  variant: _react.PropTypes.oneOf(_.values(VARIANT))
};
Loader.defaultProps = {
  variant: VARIANT.MEDIUM
};
exports.default = Loader;
;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL2xvYWRlci9sb2FkZXIuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUE7Ozs7QUFJQTs7SUFBWSxDOztBQUVaOzs7Ozs7Ozs7Ozs7OztBQUVPLElBQU0sNEJBQVU7QUFDckIsZ0JBQWMsYUFETztBQUVyQixlQUFhLFlBRlE7QUFHckIsU0FBTyxPQUhjO0FBSXJCLFVBQVEsUUFKYTtBQUtyQixTQUFPO0FBTGMsQ0FBaEI7O0lBUWMsTTs7Ozs7Ozs7Ozs7NkJBVVY7QUFBQSxVQUNDLE9BREQsR0FDYSxLQUFLLEtBRGxCLENBQ0MsT0FERDs7O0FBR1AsYUFDRSx1Q0FBSyxXQUFXLGlCQUFPLE9BQVAsQ0FBaEIsR0FERjtBQUdEOzs7Ozs7QUFoQmtCLE0sQ0FFWixTLEdBQVk7QUFDakIsV0FBUyxpQkFBVSxLQUFWLENBQWdCLEVBQUUsTUFBRixDQUFTLE9BQVQsQ0FBaEI7QUFEUSxDO0FBRkEsTSxDQU1aLFksR0FBZTtBQUNwQixXQUFTLFFBQVE7QUFERyxDO2tCQU5ILE07QUFpQnBCIiwiZmlsZSI6ImxvYWRlci5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwge1xuICBDb21wb25lbnQsXG4gIFByb3BUeXBlc1xufSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgKiBhcyBfIGZyb20gJ2xvZGFzaCc7XG5cbmltcG9ydCBzdHlsZXMgZnJvbSAnLi9sb2FkZXIuY3NzbSc7XG5cbmV4cG9ydCBjb25zdCBWQVJJQU5UID0ge1xuICBYU01BTExfV0hJVEU6ICd4c21hbGxXaGl0ZScsXG4gIFhTTUFMTF9CTFVFOiAneHNtYWxsQmx1ZScsXG4gIFNNQUxMOiAnc21hbGwnLFxuICBNRURJVU06ICdtZWRpdW0nLFxuICBMQVJHRTogJ2xhcmdlJ1xufTtcblxuZXhwb3J0IGRlZmF1bHQgY2xhc3MgTG9hZGVyIGV4dGVuZHMgQ29tcG9uZW50IHtcblxuICBzdGF0aWMgcHJvcFR5cGVzID0ge1xuICAgIHZhcmlhbnQ6IFByb3BUeXBlcy5vbmVPZihfLnZhbHVlcyhWQVJJQU5UKSlcbiAgfVxuXG4gIHN0YXRpYyBkZWZhdWx0UHJvcHMgPSB7XG4gICAgdmFyaWFudDogVkFSSUFOVC5NRURJVU1cbiAgfVxuXG4gIHJlbmRlcigpIHtcbiAgICBjb25zdCB7IHZhcmlhbnQgfSA9IHRoaXMucHJvcHM7XG5cbiAgICByZXR1cm4gKFxuICAgICAgPGRpdiBjbGFzc05hbWU9e3N0eWxlc1t2YXJpYW50XX0+PC9kaXY+XG4gICAgKTtcbiAgfVxufTtcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./~/@chartbeat/light-side/lib/components/loader/loader.js
// module id = 149
// module chunks = 0